import React, { FC, Fragment, useState } from 'react';
import { formatDate } from 'utils/format';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { Deviation } from 'models/deviations';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@apollo/client';
import { orderDeviationsTemplate } from 'apollo/templates/deviation';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';
import InfoText from 'components/shared/info-text.component';

type DeviationsDataProps = {
    orderId: string;
};
const DeviationForDentist: FC<DeviationsDataProps> = ({ orderId }: DeviationsDataProps) => {
    const { t: translate } = useTranslation(['deviations']);
    const [deviationsData, setDeviationsData] = useState<Deviation[]>([]);
    const { showBoundary } = useDenthubErrorBoundary();

    useQuery(orderDeviationsTemplate, {
        variables: { orderId: orderId },
        onCompleted: ({ orderDeviations }) => {
            if (orderDeviations) {
                setDeviationsData(orderDeviations);
            }
        },
        onError(error) {
            showBoundary(error);
        },
    });

    return (
        <Fragment>
            {deviationsData?.length > 0 ? (
                <Box>
                    {deviationsData.map((deviation) => (
                        <Box key={deviation._id} style={{ marginBottom: '22px' }}>
                            <Typography variant="h4">
                                {deviation.type}: {deviation.code} - {deviation.description}
                            </Typography>
                            <Typography variant="subtitle1" style={{ fontSize: '16px', color: 'rgb(0 0 0 / 58%)' }}>
                                {formatDate(deviation.addedOn, 'datetime')} {translate('deviations:BY')}{' '}
                                {deviation.technician}
                            </Typography>
                            <Typography
                                style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word', fontSize: '14px' }}
                                dangerouslySetInnerHTML={{ __html: deviation.report }}
                            />
                            {deviation?.actions?.map((action, index) => (
                                <Box key={index} style={{ padding: '10px' }}>
                                    <Typography variant="h4"> {translate('deviations:ACTION')}</Typography>
                                    <Typography
                                        variant="subtitle1"
                                        style={{ fontSize: '16px', color: 'rgb(0 0 0 / 58%)' }}
                                    >
                                        {formatDate(action.addedOn, 'datetime')} {translate('deviations:BY')}{' '}
                                        {action.technician}
                                    </Typography>
                                    <Typography
                                        style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word', fontSize: '14px' }}
                                        dangerouslySetInnerHTML={{ __html: action.report }}
                                    />{' '}
                                </Box>
                            ))}
                        </Box>
                    ))}
                </Box>
            ) : (
                <InfoText text={translate('deviations:NO_DEVIATIONS')} />
            )}
        </Fragment>
    );
};

export default DeviationForDentist;
